import React from 'react';

export const ConversionDataContext = React.createContext({
  appContext: null,
  tagContext: null,
  goalContext: null,
  metricsContext: null,
  instrumentation: null,
  preferenceContext: null,
});
